module.exports = __webpack_public_path__ + "static/media/tsb6ru.5f388b9c.pdf";